import { StyleSheet } from '@react-pdf/renderer';

export const resumeStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: 10,
    lineHeight: '1.5pt'
  },
  section: {
    margin: '10px',
  },
  detailSection: {
    margin: '10px',
    paddingBottom: '10px',
    borderBottom: '1px solid #4b4b4b',
  },
  header1: {
    fontSize: 20,
    textAlign: 'center',
  },
  header2: {
    fontSize: 15,
    marginBottom: '20px',
    textAlign: 'center'
  },
  subheader: {
    fontSize: 16,

    textDecoration: 'underline'
  },
  initialInfo: {
    fontSize: '12px',

  },
  text1: {
    fontSize: '12px',
    fontWeight: 100,
    marginTop: '8px',

  },

  text2: {
    fontSize: '10px',
    fontWeight: 500,

  },
  description: {
    fontSize: "10px",
    fontWeight: 500,
    marginTop: '2px'
  },

  ul: {
    marginBottom: "5px",
    fontWeight: 500,
    fontSize: "10px",
  },

  ol: {
    marginBottom: "5px",
    fontWeight: 500,
    fontSize: "10px",
  },

  li: {
    marginBottom: "5px",
    marginLeft: "10px",
    fontSize: '10px',
    fontWeight: 100,
  },
  li_description: {
    fontSize: "10px",
    fontWeight: 500,
    marginTop: '2px',
    marginLeft: "10px",
  },

  strong: {
    fontWeight: "bold",
    fontSize: "10px",
  },
  italic: {
    fontStyle: "italic",
    fontSize: "10px",
  },

  table: {
    display: "table",
    fontSize: '10px',

    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "black",

  },
  tableRow: {
    flexDirection: "row",
  },
  tableCol: {
    width: "33%",
    padding: 5,
    textAlign: 'left'
  },
  tableHeader: {
    borderBottom: "1px solid black"
  },
  watermark: {
    position: "absolute",
    top: "40%",
    left: "25%",
    transform: "rotate(-45deg)",
    zIndex: -1,
    opacity: 0.1,
    width: "50%",
    textAlign: "center",
    color: "#a0a0a0"
  },
});
